import PropTypes from 'prop-types';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import Box from './Box';
import LinkButton from './LinkButton';
const defaultChildren = /*#__PURE__*/React.createElement(Box, null, "Drag 'n' drop files here, or ", /*#__PURE__*/React.createElement(LinkButton, null, "select files"));
export const Dropzone = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children = defaultChildren,
    onFiles,
    ...props
  } = _ref;
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject
  } = useDropzone();
  const __css = {
    py: 4,
    px: 3,
    textAlign: 'center',
    borderRadius: 'round',
    bg: 'gray.1'
  };
  const variant = React.useMemo(() => {
    if (isDragAccept) return 'active';
    if (isDragReject) return 'error';
    return 'default';
  }, [isDragReject, isDragAccept]);
  React.useEffect(() => {
    if (!Array.isArray(acceptedFiles) || !acceptedFiles.length) return;
    onFiles(acceptedFiles);
  }, [acceptedFiles, onFiles]);
  return /*#__PURE__*/React.createElement(Box, getRootProps({
    __css,
    tx: 'dropzone',
    variant,
    ...props
  }), /*#__PURE__*/React.createElement("input", getInputProps()), children);
});
Dropzone.propTypes = {
  onFiles: PropTypes.func.isRequired
};
Dropzone.displayName = 'Dropzone';
export default Dropzone;